import { render, staticRenderFns } from "./StatusChangeMenu.vue?vue&type=template&id=60951fd4"
import script from "./StatusChangeMenu.vue?vue&type=script&lang=js"
export * from "./StatusChangeMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports